export function convertMsToSeconds(ms) {
    return ms / 1000;
}
